<template>
	<div class="flex align-middle items-center px-4" :class="{ 'bg-imd-blue': task.isNew }">
		<div class="font-bold w-8 mr-2">{{ index + 1 }}</div>

		<BaseInput v-model="task.name" class="mr-4 pt-4 flex-grow" maxlength="80" @input="$emit('change')" :disabled="disabled" />
		<font-awesome-icon
			:icon="['fa', 'trash-alt']"
			class="cursor-pointer lg:text-lg w-auto text-3xl text-grey-200 hover:text-red-300"
			@click="$emit('delete', task)"
			:title="$t('delete').toString()"
			v-if="!disabled"
		></font-awesome-icon>
	</div>
</template>
<script>
import BaseInput from '@/components/forms/inputs/BaseInput';

export default {
	name: 'RepairPlanTaskRow',
	components: { BaseInput },
	props: {
		task: {},
		index: {},
		disabled: { default: false },
	},
};
</script>
<style>
.bg-imd-blue {
	background-color: #0068b4;
	color: #ffffff;
}
</style>
